/**
 * History Tab Component
 *
 * Displays activity history for a raw product.
 */

import { Timeline } from '@/components/ui';
import type { TimelineItem } from '@/components/ui';

interface HistoryTabProps {
  productId: string;
}

export function HistoryTab({ productId: _productId }: HistoryTabProps) {
  // TODO: Replace with actual API call
  // const { data: history } = useProductHistory(_productId);

  // Mock data for now
  const mockHistory: TimelineItem[] = [
    { id: '1', content: 'Modification du prix fournisseur', user: 'Marie Dupont', date: '12 Jan 2024 14:32' },
    { id: '2', content: 'Mise a jour des allergenes', user: 'Jean Martin', date: '10 Jan 2024 09:15' },
    { id: '3', content: 'Mise a jour du stock minimum', user: 'Sophie Bernard', date: '08 Jan 2024 16:45' },
    { id: '4', content: 'Creation du produit', user: 'Marie Dupont', date: '05 Jan 2024 11:20' },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white border border-neutral-200 rounded-xl p-6 shadow-sm">
        <h3 className="text-base font-semibold text-dark-500 mb-4">
          Activite recente
        </h3>

        <Timeline
          items={mockHistory}
          emptyMessage="Aucune activite enregistree"
        />
      </div>

      {/* Info box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-4">
        <p className="text-sm text-neutral-600">
          L'historique complet des modifications sera disponible dans une prochaine version.
        </p>
      </div>
    </div>
  );
}
